import { t } from '../../../i18n/strings.js';

// Só mostra o que está em `methods` (quizConfig.paywall.paymentMethods) —
// a lista deve refletir o que o Stripe Checkout realmente aceita.
export default function SecureCheckout({ methods = [] }) {
  if (!methods.length) return null;
  return (
    <section className="text-center">
      <div className="font-display font-semibold text-[15px]">{t('paywallIntl.secureTitle')}</div>
      <div className="flex flex-nowrap items-center justify-center gap-2 mt-3">
        {methods.map((m) => (
          <img
            key={m.file}
            src={`/payment/${m.file}.png`}
            alt={m.label}
            width={141}
            height={97}
            loading="lazy"
            className="min-w-0 h-auto"
            style={{ width: `${Math.floor(92 / methods.length)}%`, maxWidth: 72 }}
          />
        ))}
      </div>
      <p className="text-[12px] text-ink-muted mt-2">{t('paywallIntl.secureNote')}</p>
    </section>
  );
}
